import { type FC, type ReactNode } from 'react';

import { ViewportProvider } from '@craft/ui/components/responsive';
import { type ViewportSeed } from '@craft/ui/util';

import { MuiConfig } from '@/src/components-v2/config/MuiConfig';
import { useInitializeDatadog } from '@/src/features/integrations/datadog/hooks';

import { useApplicationDiagnostics } from '../hooks';
import { ApplicationProvider } from '../providers/ApplicationProvider';
import { SnackbarProvider } from '../providers/SnackbarProvider';
import { SWRConfig } from '../providers/SWRConfig';

export const ApplicationConfigInner: FC = () => {
  useInitializeDatadog();
  useApplicationDiagnostics();

  return null;
};

export interface ApplicationConfigProps {
  readonly children: ReactNode;
  readonly initialViewportSeed?: ViewportSeed;
}

export const ApplicationConfig: FC<ApplicationConfigProps> = ({
  children,
  initialViewportSeed,
}) => (
  <ApplicationProvider>
    <MuiConfig>
      <ViewportProvider initialViewportSeed={initialViewportSeed}>
        <SnackbarProvider>
          <ApplicationConfigInner />
          <SWRConfig>{children}</SWRConfig>
        </SnackbarProvider>
      </ViewportProvider>
    </MuiConfig>
  </ApplicationProvider>
);
